import { fg } from '@atlassian/jira-feature-gating';

const ThorWivFixArchivedSubtaskBannerRelayProvider = {
	get(): boolean {
		return fg('thor_wiv_fix_archived_subtask_banner');
	},
};

export default ThorWivFixArchivedSubtaskBannerRelayProvider;
